import {normalize} from 'normalizr';
import {getHeaders, getMPPEndpoint} from '../../../helpers/endpoint';
import {statisticListSchema} from '../../../schemas/statistic';
import {receiveEntities} from '../../entities';

export const REQUEST_STATS_MPP_USERS = 'REQUEST_STATS_MPP_USERS';
export const SUCCESS_FETCH_STATS_MPP_USERS = 'SUCCESS_FETCH_STATS_MPP_USERS';
export const FAIL_FETCH_STATS_MPP_USERS = 'FAIL_FETCH_STATS_MPP_USERS';

export const fetchMPPUsersStatistics = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_STATS_MPP_USERS, payload, scope});

    fetch(getMPPEndpoint('fetchStatsMppUsers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_MPP_USERS});
        else dispatch(successFetchMPPUsersStatistics(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_STATS_MPP_USERS) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchMPPUsersStatistics(data, payload, scope) {
  return dispatch => {
    let all = {};
    const mppUsers = Object.entries(data).map(i => {
      const key = i[0];
      const stat = i[1];

      all = {
        ...all,
        mppFr: (all && all.mppFr ? all.mppFr : 0) + stat.FR,
        mppEn: (all && all.mppEn ? all.mppEn : 0) + stat.GB,
        mppEs: (all && all.mppEs ? all.mppEs : 0) + stat.ES,
        mppOther: (all && all.mppOther ? all.mppOther : 0) + stat.OTHER,
      };

      return {
        mppFr: stat.FR,
        mppEn: stat.GB,
        mppEs: stat.ES,
        mppOther: stat.OTHER,
        id: `mppUsers-${key}`,
        date: key,
      };
    });

    const normalized = normalize(mppUsers, statisticListSchema);
    dispatch(receiveEntities(normalized.entities));

    dispatch({
        type: SUCCESS_FETCH_STATS_MPP_USERS,
        receivedAt: Date.now(),
        ids: normalized.result,
        total: all,
        payload,
        scope
    });
  };
}

export const REQUEST_MPP_USERS_CONNECTIONS = 'REQUEST_MPP_USERS_CONNECTIONS';
export const SUCCESS_MPP_USERS_CONNECTIONS = 'SUCCESS_MPP_USERS_CONNECTIONS';
export const FAIL_MPP_USERS_CONNECTIONS = 'FAIL_MPP_USERS_CONNECTIONS';

export const getMPPUsersConnections = (onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_MPP_USERS_CONNECTIONS});
    if (onRequest) onRequest();

    fetch(getMPPEndpoint('fetchMPPUsersConnections'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_MPP_USERS_CONNECTIONS});
        else dispatch({type: SUCCESS_MPP_USERS_CONNECTIONS, data});

        if (onSuccess) onSuccess(data);
      })
      .catch((error, type = FAIL_MPP_USERS_CONNECTIONS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const getMPPUsersByChampionship = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (_, getState) => {
    if (onRequest) onRequest();
    fetch(getMPPEndpoint('getMPPUsersByChampionship', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) onFail && onFail(data.error);
        else if (onSuccess) {
          onSuccess(data);
        }
      })
      .catch(error => {
        if (onFail) onFail(error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/actions/entities/statistics/mppUsers.js